import { useState } from 'react'
import { colors } from 'plume-ui'
import { css } from '@emotion/react'
import { HeaderButton } from '../header-button'
import { IcomoonIcon } from '../../../../atoms/IcomoonIcon'
import Clipboard from 'react-clipboard.js'
import { Snackbar } from '@/components/atoms/Snackbar'

type Props = {
  url: string
}

export const ShareUrl: React.FC<Props> = ({ url }) => {
  const [copySucceed, setCopySucceed] = useState(false)

  const handleSuccess = () => {
    setCopySucceed(true)
  }

  return (
    <>
      <Clipboard
        component="button"
        data-clipboard-text={url}
        onSuccess={handleSuccess}
        className="copy-url"
        css={css`
          background: transparent;
          border: none;
          padding: 0;
          margin: 0;
        `}
      >
        <HeaderButton
          isLoading={false}
          tooltip={'このフィルタ設定のリンクをコピー'}
          disabled={false}
          label={'リンクコピー'}
        >
          <IcomoonIcon
            name="link"
            css={css`
              padding-right: 4px;
              vertical-align: middle;
              font-size: 20px;
              color: ${colors.black10};
            `}
          />
        </HeaderButton>
      </Clipboard>
      <Snackbar
        isShow={copySucceed}
        setIsShow={setCopySucceed}
        text={'リンクをコピーしました'}
      />
    </>
  )
}
